import * as lookups from "mortar/endpoints/lookups";

export const clientAuthStatusLookup = () => lookups.clientAuthStatusLookup();
